import { handleClick } from '@/components/OutLink'
import { PlatformEnum } from '@/service/api/types'

export const SAGAWA_DELIVERY_BOOKING_URL =
  'https://m.ctrip.com/webapp/you/gsshopping/shops/2/0.html?seo=0&ishidenavbar=yes&poiId=154106803&share=1&bid=8&pid=6&cid=600083&openapp=3&wxpopup=205&inpopup=true&open_in_browser=true'

export const SAGAWA_PRECAUTIONS_AND_FAQ_URL =
  'https://file.bilionpass.com/sagawa_luggage_service_customer_web_revised.html'

export const openSagawaDeliveryBooking = () => {
  return handleClick({
    platform: PlatformEnum.SGW,
    linUrl: SAGAWA_DELIVERY_BOOKING_URL,
  })
}
